import { useAuthStore } from '@/store/auth-store'

export function ImpersonationBanner() {
  const user = useAuthStore((s) => s.user)
  const impersonatedBy = useAuthStore((s) => s.impersonatedBy)
  const endImpersonation = useAuthStore((s) => s.endImpersonation)

  const handleExit = () => {
    endImpersonation()
    window.close()
    // Fallback if window.close() is blocked (wasn't opened by script)
    setTimeout(() => {
      window.location.href = '/login'
    }, 200)
  }

  return (
    <div className="imp-banner">
      <div className="imp-banner-content">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
        <span>
          Viewing as <strong>{user?.displayName || user?.email}</strong>
          {user?.role && <span className="imp-banner-role">{user.role}</span>}
          {impersonatedBy && (
            <span className="imp-banner-actor"> — Impersonated by {impersonatedBy.email}</span>
          )}
        </span>
      </div>
      <button className="imp-banner-exit" onClick={handleExit}>
        Exit Impersonation
      </button>
    </div>
  )
}
